import React from 'react';

const Welcome = ({ setPage }) => {
  return (
    <div className="animate-fade-in space-y-8">
      <div className="text-center p-10 bg-gradient-to-br from-[#2E5FA7] to-[#244C86] rounded-2xl text-white shadow-md">
        <h1 className="text-3xl md:text-4xl font-bold mb-2">VEIT Total Technology Alignment Tool</h1>
        <div className="text-base font-medium text-blue-100 mb-6 uppercase tracking-wider">For Growing Organizations (25–500 Employees)</div>
        <p className="text-lg max-w-2xl mx-auto mb-8 leading-relaxed opacity-95">
          Technology should accelerate your business—not slow it down.<br />
          This alignment review helps us understand where your environment stands today, 
          where risk or inefficiencies may exist, and how to build a smarter path forward with a unified strategy.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          <div className="bg-white/10 border border-white/20 rounded-xl p-6 text-center backdrop-blur-sm transition-transform hover:-translate-y-1">
            <div className="text-3xl mb-3">💰</div>
            <div className="font-bold text-sm mb-1">Reduce Cost & Waste</div>
            <div className="text-xs text-blue-100">Optimize spend by eliminating overlapping vendors and tools.</div>
          </div>
          <div className="bg-white/10 border border-white/20 rounded-xl p-6 text-center backdrop-blur-sm transition-transform hover:-translate-y-1">
            <div className="text-3xl mb-3">🛡️</div>
            <div className="font-bold text-sm mb-1">Improve Security</div>
            <div className="text-xs text-blue-100">Protect your data with enterprise-grade defenses and vCISO guidance.</div>
          </div>
          <div className="bg-white/10 border border-white/20 rounded-xl p-6 text-center backdrop-blur-sm transition-transform hover:-translate-y-1">
            <div className="text-3xl mb-3">📈</div>
            <div className="font-bold text-sm mb-1">Enable Growth</div>
            <div className="text-xs text-blue-100">Scale seamlessly with modern cloud and robust IT infrastructure.</div>
          </div>
        </div>
        
        <button 
          onClick={() => setPage('context')}
          className="bg-white text-[#2E5FA7] px-8 py-3.5 rounded-xl font-bold shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all inline-flex items-center gap-2"
        >
          Start Alignment Review →
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
          <h3 className="text-[#2E5FA7] font-bold text-xl mb-6 flex items-center gap-2">
            <span className="text-2xl">🤝</span> The Total Technology Provider Advantage
          </h3>
          <p className="text-gray-600 text-sm mb-6 leading-relaxed">
            Managing multiple vendors for IT, Print, and Security creates finger-pointing, hidden costs, and operational friction. Visual Edge IT eliminates this by providing a single point of accountability.
          </p>
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <div className="mt-0.5 text-[#28A745]">✓</div>
              <div>
                <div className="font-bold text-sm text-gray-800">One Unified Strategy</div>
                <div className="text-xs text-gray-500">Ensure your IT, security, and print infrastructure work together seamlessly.</div>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <div className="mt-0.5 text-[#28A745]">✓</div>
              <div>
                <div className="font-bold text-sm text-gray-800">Streamlined Support</div>
                <div className="text-xs text-gray-500">One call for everything. No more vendors blaming each other for issues.</div>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <div className="mt-0.5 text-[#28A745]">✓</div>
              <div>
                <div className="font-bold text-sm text-gray-800">National Scale, Local Service</div>
                <div className="text-xs text-gray-500">Backed by 90+ locations nationwide with 24/7/365 US-based support centers.</div>
              </div>
            </li>
          </ul>
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
          <h3 className="text-[#2E5FA7] font-bold text-xl mb-6">What to Expect</h3>
          <div className="space-y-6">
            <div className="flex gap-4">
              <div className="bg-[#F4F6F9] w-12 h-12 rounded-full flex items-center justify-center text-xl shrink-0">📋</div>
              <div>
                <div className="font-bold text-gray-800 mb-1">1. 15-Minute Conversation</div>
                <div className="text-sm text-gray-600">Quick, focused questions about your current technology environment, security posture, and business goals.</div>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="bg-[#F4F6F9] w-12 h-12 rounded-full flex items-center justify-center text-xl shrink-0">📊</div>
              <div>
                <div className="font-bold text-gray-800 mb-1">2. Clear Assessment</div>
                <div className="text-sm text-gray-600">Instantly understand where gaps, risks, and cost-saving opportunities exist across your domains.</div>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="bg-[#F4F6F9] w-12 h-12 rounded-full flex items-center justify-center text-xl shrink-0">🗺️</div>
              <div>
                <div className="font-bold text-gray-800 mb-1">3. Actionable Roadmap</div>
                <div className="text-sm text-gray-600">Receive a phased, strategic plan aligned to your priorities to stabilize, standardize, and innovate.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;